<template>
    <rkm-form
        v-if="model && form && additionals"
        ref="Form"
        show-legend
    >
        <rkm-area
            title="Informações da solicitação"
        >

            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-input
                        label="Data da abertura"
                        readonly
                        v-model="form.dataSolicitacao"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        label="Dias em aberto"
                        readonly
                        v-model="form.diasSolicitacaoAberto"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        label="Unidade solicitante"
                        readonly
                        v-model="form.unidadeSolicitante"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        label="Infraestrutura solicitante"
                        readonly
                        v-model="form.infraestruturaSolicitante"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        label="Usuário Solicitante"
                        readonly
                        v-model="form.usuarioSolicitante"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        label="Grupo"
                        readonly
                        v-model="form.grupo"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        label="Subgrupo"
                        readonly
                        v-model="form.subgrupo"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        label="Serviço"
                        readonly
                        v-model="model.servico"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-textarea
                        :rules="validations.assunto"
                        label="Assunto"
                        readonly
                        v-model="form.assunto"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-textarea
                        :rules="validations.detalhe"
                        label="Detalhe"
                        readonly
                        v-model="form.detalhe"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-area
                title="Causa(s) provável(is)"
            >

                <causaProvavelList
                    :data="form.causasProvaveis"
                    @openModalObservacoes="handleOpenModal"
                    ref="CausaProvavelLista"
                />

                <causaProvavelListObservacao
                    :data="form.causasProvaveis"
                    ref="ModalOberservacao"
                />

            </rkm-area>

        </rkm-area>
        <rkm-area
            title="Ações"
        >
        </rkm-area>
        <rkm-row>
            <rkm-col>
                <formAcoes
                    :additionals="additionals"
                    :blockEdit="blockEdit"
                    :form="form"
                    :model="model"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>

// Components.
import formAcoes from './components/acoes/Form'
import causaProvavelList from './components/causa-provavel/List'
import CausaProvavelListObservacao from './components/causa-provavel/Modal'

// Vuex.
import { mapActions } from 'vuex'

// Others.
import moment from 'moment'

// Mixins.
import { repository, stringCase, object, error, file } from '@/mixins'

// Enums.
import statusTipo from '@/enums/manutencao/statusTipo'

export default {
    components: {
        formAcoes,
        causaProvavelList,
        CausaProvavelListObservacao
    },
    computed: {
        validations() {

            return {
                infraestruturaSolicitanteId: {
                    required: true,
                },
                usuarioSolicitante: {
                    required: true,
                },
                grupoId: {
                    required: true,
                },
                subGrupoId: {
                    required: true,
                },
                servicoId: {
                    required: true,
                },
                assunto: {
                    min: 3,
                    max: 150,
                },
                detalhe: {
                    min: 3,
                    max: 1000,
                }
            }
        },
        fields() {
            return {
                autocomplete: {
                    usuarioSolicitante: [
                        { key: 'cadastro_cidadao.nome', searchable: true },
                    ],
                },
            }
        },
        canFinalize() {

            return !this.form.pendenteFinalizacao;
        },
        canCancel() {

            if (this.form.statusTipoId === this.enums.statusTipo.CANCELADO || this.form.pendenteFinalizacao) {
                return true;
            } else {
                return false;
            }
        },
        statusisFinalizado() {

            return this.form.pedenteFinalizacao || this.form.statusTipoId === this.enums.statusTipo.CANCELADO;
        },
    },
    created() {

        this.repositories = {
            gerenciamento: this.getConectaSusRepository('manutencao.gerenciamento'),
            impressao: this.getConectaSusRepository('impressao.manutencao'),
        }

        this.load()
    },
    data: () => ({
        model: null,
        additionals: null,
        form: null,
        others: { moment },
        enums: { statusTipo },
        blockEdit: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.$nextTick().then(() => {
                this.setLoading()

                if (this.id) {

                    this.repositories.gerenciamento.edit(this.id)
                        .then(({ data }) => {

                            if (data.model && data.form && data.additionals) {

                                this.model = this.clone(data.model)
                                this.form = this.clone(data.form)
                                this.additionals = this.clone(data.additionals)

                                if (this.form.statusTipoId === this.enums.statusTipo.CANCELADO || this.form.pedenteFinalizacao) {
                                    this.blockEdit = true;
                                }
                            }
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                }
            })
        },
        checkTravaCampos() {

            return this.id !== null
        },
        async print(id) {

            await new Promise(resolve => {
                this.showConfirmation(
                    'Deseja imprimir a solicitação?',
                    async () => {
                        await this.confirmPrint(id);
                        resolve();
                    },
                    async () => {
                        resolve();
                    }
                );
            });
        },
        confirmPrint(id) {

            this.setLoading();

            this.repositories.impressao.gerenciamento(id)
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(async valid => {

                    if (!valid) return

                    this.setLoading()

                    try {
                        const request = this.repositories.gerenciamento.update(this.id, this.prepareData());

                        const { data } = await request
                        this.unsetLoading();

                        await this.print(data.id);
                        this.showSaveNotification()
                        this.$emit('save', data)
                    } catch (error) {
                        this.handleError(error)
                    } finally {
                        this.unsetLoading()
                    }
                })
        },
        prepareData() {

            if (this.model.dataAgendamento) {
                this.model.dataAgendamentoFormatada = this.model.dataAgendamento;
            } else {
                this.model.dataAgendamentoFormatada = null;
            }
            return this.camelObjectKeysToSnakeRecursive(this.model);
        },
        finalize() {

            this.$refs.Form.validate()
                .then(async valid => {

                    if (!valid) return
                    this.setLoading()

                    try {

                        const dataRequest = {
                            acao: 'finalizar',
                        }

                        const request = this.repositories.gerenciamento.update(this.id, dataRequest);

                        const { data } = await request
                        this.unsetLoading()

                        this.showSaveNotification()
                        this.$emit('save', data)
                    } catch (error) {
                        this.handleError(error)
                    } finally {
                        this.unsetLoading()
                    }
                })
        },
        handleOpenModal(causaProvavel) {

            const index = this.form.causasProvaveis.indexOf(causaProvavel)

            this.$refs.ModalOberservacao.open(index)
        },
    },
    mixins: [ repository, stringCase, object, error, file ],
    props: {
        id: { type: Number },
    },
}
</script>

<style scoped>
    .space-up {
        margin-top: 15px;
    }
</style>